import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

import PageTitleSection from '../../components/PageTitleSection/PageTitleSection';
import QuestionsTab from './QuestionsTab/QuestionsTab';
import KnowledgeBaseTab from './KnowledgeBaseTab/KnowledgeBaseTab';
import WebsitesTab from './WebsitesTab/WebsitesTab';
import BuildBotButton from '../../components/BuildBotButton/BuildBotButton';
import PageContentContainer from '../../components/PageContentContainer/PageContentContainer';
import CustomTabs from '../../components/CustomTabs/CustomTabs';

function TrainingPage(): React.ReactElement {
  const location = useLocation();
  const [selectedTab, setSelectedTab] = React.useState('faqs');

  return (
    <>
      <Helmet>
        <title>Japeto - Training</title>
      </Helmet>
      <PageTitleSection title='Training'>
        <BuildBotButton />
      </PageTitleSection>
      <PageContentContainer>
        <CustomTabs
          tabs={[
            {
              label: 'FAQs',
              value: 'faqs',
              content: (
                <QuestionsTab
                  returnQuery={location.state?.returnQuery}
                  returnPage={location.state?.returnPage}
                  returnResultsPerPage={location.state?.returnResultsPerPage}
                />
              )
            },
            {
              label: 'Knowledgebase',
              value: 'knowledgebase',
              content: <KnowledgeBaseTab />
            },
            {
              label: 'Websites',
              value: 'websites',
              content: <WebsitesTab />
            }
          ]}
          defaultValue='faqs'
          value={selectedTab}
          onValueChange={setSelectedTab}
          hasContentBox
          fullWidthContent={
            selectedTab === 'faqs' ||
            selectedTab === 'knowledgebase' ||
            selectedTab === 'websites'
          }
        />
      </PageContentContainer>
    </>
  );
}

export default TrainingPage;
